import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {fetchWebAdvertisement} from "../../store/admin-cms-actions";
import SingleCommercial from "./SingleCommercial/SingleCommercial";
import styles from './Commercials.module.scss';
import Button from "../UI/Buttons/Button/Button";
import NewCommercial from "./NewCommercial/NewCommercial";
import NotificationMessage from "../UI/NotificationMessage/NotificationMessage";

const WebCommercials = () => {

    const dispatch = useDispatch();
    const createNewAdvertisementSuccess = useSelector((state:RootState) => state.adminCMS.createNewAdvertisementSuccess);
    const updateAdvertisementSuccess = useSelector((state:RootState) => state.adminCMS.updateAdvertisementSuccess);

    const webCommercials = useSelector((state: RootState) => state.adminCMS.webAdvertisements)
    const loadingWebCommercials = useSelector((state: RootState) => state.adminCMS.fetchWebAdvertisementsStart)

    const [newAdvModalVisible, setNewAdvModalVisible] = useState(false);

    const [notificationMessageVisible, setNotificationMessageVisible] = useState(false);
    const [updateNotificationMessageVisible, setUpdateNotificationMessageVisible] = useState(false);


    useEffect(() => {
        if (webCommercials.length === 0) {
            dispatch<any>(fetchWebAdvertisement())
        }
    }, [])

    useEffect(() => {
        if(updateAdvertisementSuccess) {
            setUpdateNotificationMessageVisible(true)
            setTimeout(()=> {
                setUpdateNotificationMessageVisible(false)
            }, 5000)
        }
    }, [updateAdvertisementSuccess])

    useEffect(() => {
        if(createNewAdvertisementSuccess) {
            setNotificationMessageVisible(true)
            setTimeout(()=> {
                setNotificationMessageVisible(false)
            }, 5000)
        }
    }, [createNewAdvertisementSuccess])

    const createNewCommercial = () => {
        setNewAdvModalVisible(true)
    }

    const closeNewCommercialModal =()=> {
        setNewAdvModalVisible(false)
    }

    return (
        <>
            <div className={styles.CommercialPageHeader}>
                <span style={{fontSize: "24px"}}>Podešavanje reklama za web</span>
                <Button buttonType='blue' style={{width: '200px'}} onClick={createNewCommercial}>Dodaj reklamu</Button>
            </div>
            <div className={styles.CommercialImages}>
                {webCommercials.length > 0 && !loadingWebCommercials &&
                    webCommercials.map((commercial: any, index: number) => {
                        return (
                            <SingleCommercial className={styles.SingleCommercialWeb} key={index} commercial={commercial}
                                              web/>
                        )
                    })}
            </div>

            {newAdvModalVisible &&
                <NewCommercial web show={newAdvModalVisible} closeNewCommercialModal={closeNewCommercialModal}/>
            }

            {notificationMessageVisible &&
                <NotificationMessage onClick={() => setNotificationMessageVisible(false)}>
                    Uspešno ste dodali reklamu!
                </NotificationMessage>
            }
            {updateNotificationMessageVisible &&
                <NotificationMessage onClick={() => setUpdateNotificationMessageVisible(false)}>
                    Uspešno ste ažurirali reklamu!
                </NotificationMessage>
            }

        </>
    );
};

export default WebCommercials;